import React, { useState } from "react";
import { useGetTenderApiQuery } from "../../redux/services/apiHome";
import Loader from "../../components/Loader";
import TenderSearchBar from "../../components/TenderSearchBar";
import { convertDateFormat } from "../../Utils/utils";
import InnerBannerBreadcrumb from "../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useLanguageTranslation } from "../../hooks/useLanguageTranslation";
import { useSelector } from "react-redux";
import PaginationNew from "../../components/Pagination/PaginationNew";
import PageLastUpdated from "../../components/shared/PageLastUpdated";
import { useTableResponsive } from "../../hooks/useTableResponsive";
import useSeo from "../../hooks/useSeo";
import { useLocation } from "react-router-dom";
import PdfZipItem from "../../components/PdfZipItem";

const ListOfTenders = () => {
  const { getText } = useLanguageTranslation();
  const { languageType } = useSelector((state) => state.homeSlice);
  const [currentPage, setCurrentPage] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");

  const {
    data: listOfTendersData = [],
    isLoading: listOfTendersDataIsLoading,
    isFetching: listOfTendersDataIsFetching, // Track fetching state
  } = useGetTenderApiQuery({
    page: currentPage, // default to 1 if currentPage is empty
    title: searchTerm,
    lang: languageType,
  });

  useTableResponsive(listOfTendersData);

  const lastUpdatedOn = listOfTendersData?.tender_data?.[0]?.changed_date;

  const totalPages = listOfTendersData?.total_pages - 1;

  const handleSubmitSearch = (inputText) => {
    setCurrentPage("");
    setSearchTerm(inputText);
  };

  // for SEO
  const { pathname } = useLocation();
  const { innerBannerTitle, innerBannerImage } = useSeo({ pathname });

  if (listOfTendersDataIsLoading || listOfTendersDataIsFetching) {
    return <Loader />;
  }
  return (
    <>
      <InnerBannerBreadcrumb
        title={getText("Tender", "निविदा")}
        titleLink="/tender/list-of-tenders"
        levelTwo={true}
        levelThree={false}
        bannerImage={innerBannerImage}
        titleTwo={innerBannerTitle}
        isActive={innerBannerTitle}
      />

      <div className="inner-container">
        <div className="container">
          <div className="container">
            <div className="row">
              <div className="col-12 col-md-6 col-lg-6 mb-3">
                <TenderSearchBar
                  searchTerm={searchTerm}
                  setSearchTerm={setSearchTerm}
                  // title={getText("Tender Number", "निविदा संख्या")}
                  title={getText("Tender", "निविदा")}
                  // title={getText("Search", "खोज")}
                  handleSubmitSearch={handleSubmitSearch}
                  setCurrentPage={setCurrentPage}
                />
              </div>
              <div className="col-12 col-md-6 col-lg-6 mb-3">
                {/* <PageLastUpdated lastUpdatedOn={lastUpdatedOn} /> */}
              </div>
            </div>

            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                <div className="table-responsive">
                  <table className="table table-striped custom-table">
                    <thead className="thead-dark">
                      <tr>
                        <th>{getText("S.No.", "क्र. सं.")}</th>
                        <th>{getText("Tender Number", "निविदा संख्या")}</th>
                        <th className="no-wrap-td">
                          {getText("Tender Date", "निविदा दिनांक")}
                        </th>
                        <th>{getText("Tender Description", "निविदा विवरण")}</th>
                        <th>{getText("Corrigendum", "शुद्धिपत्र")}</th>
                        <th className="no-wrap-td">
                          {getText("Remarks", "टिप्पणी")}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {listOfTendersData?.tender_data?.length > 0 ? (
                        listOfTendersData?.tender_data?.map((item, index) => (
                          <tr key={index}>
                            <td data-key={getText("S.No.", "क्र. सं.")}>
                              {item.count}
                            </td>
                            <td
                              className="no-wrap-td"
                              data-key={getText(
                                "Tender Number",
                                "निविदा संख्या",
                              )}
                            >
                              <a
                                className="d-block mb-2"
                                href={item.uri}
                                target="_blank"
                              >
                                {item.title}
                              </a>
                            </td>
                            {/* <td className="no-wrap-td">
                              {convertDateFormat(item.field_tender_date)}
                            </td> */}
                            <td
                              className="no-wrap-td"
                              data-key={getText("Tender Date", "निविदा दिनांक")}
                            >
                              {convertDateFormat(item.field_tender_date_value)}
                            </td>

                            <td
                              data-key={getText(
                                "Tender Description",
                                "निविदा विवरण",
                              )}
                              dangerouslySetInnerHTML={{
                                __html:
                                  item.field_short_notice_inviting_bids_value,
                              }}
                            ></td>
                            <td
                              className="no-wrap-td"
                              data-key={getText("Corrigendum", "शुद्धिपत्र")}
                            >
                              <div>
                                {item.corrigendum.files?.map(
                                  (subitem, index) => (
                                    <PdfZipItem
                                      key={index}
                                      filePath={subitem?.corrigendum_uri}
                                      title={
                                        subitem.corrigendum_file_description
                                      }
                                      filesize={subitem.file_size}
                                    />
                                  ),
                                )}
                              </div>
                            </td>
                            <td
                              className="no-wrap-td"
                              data-key={getText("Remarks", "टिप्पणी")}
                            >
                              <div>
                                {item?.detailed_bid_documents?.files?.map(
                                  (subitem, index) => (
                                    <PdfZipItem
                                      key={index}
                                      filePath={subitem?.bid_uri}
                                      title={subitem.file_description}
                                      filesize={subitem.file_size}
                                    />
                                  ),
                                )}
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="6" className="text-center">
                            {getText(
                              "No records found",
                              "कोई रिकॉर्ड नहीं मिला",
                            )}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                <PaginationNew
                  setCurrentPage={setCurrentPage}
                  currentPage={currentPage}
                  totalPages={totalPages}
                />
              </div>
            </div>
            <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
          </div>
        </div>
      </div>
    </>
  );
};

export default ListOfTenders;
